/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Footer_DiscordInputs */

const en_wc_footer_discord = /** @type {(inputs: Wc_Footer_DiscordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ArtCraft Discord`)
};

/**
* | output |
* | --- |
* | "ArtCraft Discord" |
*
* @param {Wc_Footer_DiscordInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_footer_discord = /** @type {((inputs?: Wc_Footer_DiscordInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Footer_DiscordInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_footer_discord(inputs)
});
export { wc_footer_discord as "wc.footer.discord" }